import { render, staticRenderFns } from "./AddTucowsRegistrar.vue?vue&type=template&id=66b1d389"
import script from "./AddTucowsRegistrar.vue?vue&type=script&lang=js"
export * from "./AddTucowsRegistrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports